import { EnvVars } from './env-vars';

const dep = {
  siteDomain: '[___ key "global/org_baoying_deploy_SiteDomain" ___]',
  amDomain: '[___ key "package/forgerock-am/baoying_AmDomain" ___]',
  recaptchaBaoyingOn: '[___ key "package/login-service/recaptchaBaoyingOn" ___]',
  sensorsDataProjectName: '[___ key "global/sensorsprojectname" ___]',
  kakaoTalkMarkets: '[___ key "package/static-sso/kakaoTalkMarkets" ___]',
};

export const environment: EnvVars = {
  app: {
    production: true,
    ssoAccessToken: 'access-token',
    domain: dep.siteDomain,
    frogBaseUrl: `https://api.${dep.amDomain}/sso/`,
    redirectUris: {
      default: `https://www.${dep.siteDomain}/hub/#/home`,
    },
    frConfig: {
      frogClientId: 'ForgeRockSDKClient',
      frogRedirectUri: `https://sso.${dep.siteDomain}/callback.html`,
      frogScope: 'openid profile',
      frogTree: 'sdkAuthTree',
    },
    recaptchaOn: dep.recaptchaBaoyingOn,
    kakaoTalkMarkets: dep.kakaoTalkMarkets,
    shopBaseUrl: `https://shop.${dep.siteDomain}/shop`,
    hubBaseUrl: `https://www.${dep.siteDomain}/hub/#/`,
    dotComBaseUrl: `https://www.${dep.siteDomain}/ux/dotcom/`,
    cartBaseUrl: `https://www.${dep.siteDomain}/ux/cart`,
    shopSecureForwardUrl: `https://www.${dep.siteDomain}/frame/shopSecureForward.jsp?url=`,
    defaultTitle: 'BAOYING',
    defaultDescription: 'SingleSignOn',
    pwdStrengthScoreMin: '[___ key "global/password_strength_score_min" ___]',
    isBaoying: true,
  },
  lib: {
    ssoIdToken: 'id-token',
    loginRealm: 'baoying',
    loginServiceUrl: `https://api.${dep.siteDomain}/auth/ws`,
    loginAppUrl: `https://sso.${dep.siteDomain}/`,
    i18nService: `https://api.${dep.siteDomain}/i18n`,
    recaptchaV3SiteKey: '', //removing this key disables reCaptchaV3
    gatewayUrl: `https://api.${dep.siteDomain}/sso-app-gateway/`,
    docSvcUrl: '',
    imageServiceUrl: `https://www.${dep.siteDomain}/image-service`,
    sensorDataLog: dep.sensorsDataProjectName !== 'production',
    sensorDataUrl: `https://baoying.datasink.sensorsdata.cn/sa?project=${dep.sensorsDataProjectName}&token=[___ key "global/sensorstoken" ___]`,
    DYNATRACE_URL: '[___ key "global/dynatraceUrl" ___]',
    DYNATRACE_KEY: '[___ key "package/hub/dynatraceKey" ___]',
  },
};
